/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterClinicDto } from '../../models/filter-clinic-dto';
import { ResponseClinicDto } from '../../models/response-clinic-dto';

export interface ClinicsControllerFilter$Params {
  
    /**
     * The filtering criteria
     */
    body: FilterClinicDto
}

export function clinicsControllerFilter(http: HttpClient, rootUrl: string, params: ClinicsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseClinicDto>>> {
  const rb = new RequestBuilder(rootUrl, clinicsControllerFilter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseClinicDto>>;
    })
  );
}

clinicsControllerFilter.PATH = '/thalea-clinics/clinics/filter';
